import { LlamadasAlertsService } from './Servicios/llamadas-alerts.service';
import { Router } from '@angular/router';
import { ProcesosGlobalesService } from './Servicios/procesos-globales.service';
import { InterceptorService } from './Servicios/Interceptor/interceptor.service';
import { VariablesService } from 'src/app/Servicios/variables.service';
import { Component } from '@angular/core';
import { Platform, ToastController } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { SwUpdate } from '@angular/service-worker';
import { ServiciosService } from './Servicios/servicios.service';
import { App, AppState } from '@capacitor/app';
import { getRemoteConfig, getValue, fetchAndActivate } from "firebase/remote-config";


import { Storage } from '@capacitor/storage';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    public interceptorService: InterceptorService,
    public toastController: ToastController,
    public procesosGlobales: ProcesosGlobalesService,
    public llamadasAlerts: LlamadasAlertsService,
    public variables: VariablesService,
    public router: Router,
    // ACTUALIZAR PWA
    public swUpdate: SwUpdate,
    public servicio: ServiciosService) {
    this.initializeApp();

    //ACTUALIZAR PWA
    this.actualizarVersion();
    this.controlRefreshPage();
    // this.iniciarRemoteConfig();

  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });

  }

 async logOff() {

    Storage.clear()
    .then(() => {
      this.variables.loginCorrecto = false;
      this.variables.tokenLogin = null;
      this.variables.recordarUsuario = false;
      this.variables.metodoAcceso = "CredencialALO";
      this.variables.empresasUsuario = [];
      this.variables.empresaSeleccionada = null;
      this.variables.usuario = null;
      this.variables.pwd = null;
      this.router.navigateByUrl('/', { replaceUrl: true })

    })


    //this.variables.credencialRetoValida = null;
    // if (!this.variables.recordarUsuario) {
    //   this.variables.usuario = '';
    //   this.variables.pwd = '';
    //   this.variables.recordarUsuario = false;
    // }

  }

  async iniciarRemoteConfig() {

    // this.variables.clavePwdEmpresas = "Ej69Tm9qmHYLWTaf";

    const remoteConfig = getRemoteConfig();

    remoteConfig.settings = {
      fetchTimeoutMillis: 100000,
      minimumFetchIntervalMillis: 100000
    };

    await fetchAndActivate(remoteConfig)
      .then((res) => {
        const accesoempresas = getValue(remoteConfig, "accesoempresas").asString();
        this.variables.clavePwdEmpresas = accesoempresas;
        console.log("Remote config, accesoempresas: ", res, accesoempresas);

      })
      .catch((err) => {
        console.log("Error al hacer fetch remote config", err);
      })

  }

  controlRefreshPage() {
    /* console.log("Rutaaaaaaaaaa", this.router.url, document.location.href);
    console.log(this.router.url != '/');
    console.log(this.router.url == '/'); */

    this.procesosGlobales.obtenerEnStorage('credencialAcceso')
      .then((res) => {
        console.log("Datos despues del refresh, ", res);

        if (res) {

          if (res.metodoAcceso == "CredencialALO") {

            this.variables.metodoAcceso = res.metodoAcceso

            this.variables.empresasUsuario = res.credencial.empresasUsuario;
            this.variables.empresaSeleccionada = res.credencial.empresaSeleccionada;
            this.variables.pwd = res.credencial.password;
            this.variables.usuario = res.credencial.correo;
            this.variables.tokenLogin = res.credencial.tokenLogin;
            this.variables.recordarUsuario = res.credencial.recordarUsuario;
            this.variables.credencialRetoValida = res.credencial.credencialRetoValida;

            this.variables.loginCorrecto = true;

            console.log("Datos de storage asignados", this.variables.empresaSeleccionada);
            this.procesosGlobales.eliminarLocalStorage('credencialAcceso');

          } else if (res.metodoAcceso == "Empresa") {

            this.variables.metodoAcceso = res.metodoAcceso

            this.variables.empresasUsuario = res.credencial.empresasUsuario;
            this.variables.empresaSeleccionada = res.credencial.empresaSeleccionada;
            this.variables.credencialesEmpresa = res.credencial.credencialEmpresa
            this.variables.pwd = res.credencial.password;
            this.variables.usuario = res.credencial.correo;
            this.variables.tokenLogin = res.credencial.tokenLogin;
            this.variables.recordarUsuario = res.credencial.recordarUsuario;
            this.variables.credencialRetoValida = res.credencial.credencialRetoValida;

            this.variables.loginCorrecto = true;

            console.log("Datos de storage asignados", this.variables.empresaSeleccionada);
            this.procesosGlobales.eliminarLocalStorage('credencialAcceso');

            /* this.router.navigate(['']);
            this.llamadasAlerts.presentAlert("Credenciales", "Tiene que volver a iniciar sesión mediante sus credenciales, o accediendo desde ALO")
            this.procesosGlobales.eliminarLocalStorage('credencialAcceso'); */
          }

        }

      })


    /*  window.addEventListener("beforeunload", function (e) {
       var confirmationMessage = "\o/";
       e.returnValue = confirmationMessage;     // Gecko, Trident, Chrome 34+
       return confirmationMessage;           // Gecko, WebKit, Chrome <34
     }); */

    App.addListener('appStateChange', async (state: AppState) => {
      console.log('App state changed. Is active?', state.isActive);
      this.variables.appSegundoPlano = state.isActive;
      if (this.variables.appSegundoPlano) {
        // VUELTA A LA APP DESDE SEGUNDO PLANO
      } else {
        // LA APP SE VA A SEGUNDO PLANO, BIEN POR QUE SE VA A RECARGAR LA PAGINA O PORQUE SE VA A DEJAR EN SEGUNDO PLANO
        console.log("Ruta desde la que parte", this.router.url);

        if ((this.router.url != '/' && this.router.url != '/login') && this.variables.loginCorrecto) {
          console.log("Url en la que estamos es dinstinta que la del login");

          // if (this.variables.metodoAcceso == "CredencialALO") { //CREDENCIALES EN LOGIN
          if (this.interceptorService.tokenValido()) {
            let storageCredencial
            if (this.variables.metodoAcceso == "CredencialALO") {
              storageCredencial = {
                metodoAcceso: this.variables.metodoAcceso,
                credencial: {
                  correo: this.variables.usuario,
                  password: this.variables.pwd,
                  tokenLogin: this.variables.tokenLogin,
                  recordarUsuario: this.variables.recordarUsuario,
                  empresasUsuario: this.variables.empresasUsuario,
                  empresaSeleccionada: this.variables.empresaSeleccionada,
                  credencialRetoValida: this.variables.credencialRetoValida
                }

              }
            } else if (this.variables.metodoAcceso == "Empresa") {
              storageCredencial = {
                metodoAcceso: this.variables.metodoAcceso,
                credencial: {
                  /* correo: this.variables.usuario,
                  password: this.variables.pwd, */
                  tokenLogin: this.variables.tokenLogin,
                  recordarUsuario: this.variables.recordarUsuario,
                  empresasUsuario: this.variables.empresasUsuario,
                  empresaSeleccionada: this.variables.empresaSeleccionada,
                  credencialEmpresa: this.variables.credencialesEmpresa,
                  credencialRetoValida: this.variables.credencialRetoValida

                }

              }
            }


            console.log("Se guarda en storage: ", storageCredencial);

            await this.procesosGlobales.guardarEnStorage("credencialAcceso", JSON.stringify(storageCredencial));
          }

          // }
        }
      }
    });
  }

  actualizarVersion() {
    if (!this.swUpdate.isEnabled) {
      console.log("SwUpdate not enabled");
      return
    } else {
      console.log("SwUpdate enabled");
    }
    this.swUpdate.checkForUpdate().then(() => console.log('Comprobada version PWA al abrir aplicacion'));
    this.swUpdate.available.subscribe(async (event) => {

      this.servicio.presentLoading("Actualizando app ...");
      this.swUpdate.activateUpdate().then(() => {
        location.reload();
        this.servicio.dissmisLoading;

      });
    });
  }
}
